import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../Components/Sidebar";
import PageComponent from "../../Components/PageComponent";
import { MdOutlineDeleteForever } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { addCounsellor, getCounsellor, updateCounsellor, deleteCounsellor } from "../../controllers/counsellor.controller";
import DeletePopup from "../../Components/DeletePopup";
import UpdateCounsellorPopup from "./UpdateCounsellorPopup";

function Student_Counseller() {
    const dispatch = useDispatch();
    const [counsellors, setCounsellors] = useState([]);
    const [name, setName] = useState("");
    const [designation, setDesignation] = useState("");
    const [tele, setTele] = useState("");
    const [email, setEmail] = useState("");
    const [editId, setEditId] = useState(null);

    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
    const [selectedCounsellor, setSelectedCounsellor] = useState(null);

    const [isUpdatePopupOpen, setIsUpdatePopupOpen] = useState(false); // New state for update popup
    const [counsellorToUpdate, setCounsellorToUpdate] = useState(null); // New state to store the counsellor to update

    useEffect(() => {
        fetchCounsellors();
    }, []);

    const fetchCounsellors = async () => {
        try {
            const response = await getCounsellor();
            setCounsellors(response.data.data);
        } catch (error) {
            console.error("Error fetching counsellors:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await addCounsellor({ name, designation, tele, email });
            alert("Counsellor added successfully!");
            setName("");
            setDesignation("");
            setTele("");
            setEmail("");
            fetchCounsellors();
        } catch (error) {
            console.error("Error saving counsellor:", error);
            alert("Failed to save counsellor.");
        }
    };

    const handleDeleteClick = (counsellor) => {
        setSelectedCounsellor(counsellor);
        setIsDeletePopupOpen(true);
    };

    const handleConfirmDelete = async () => {
        try {
            if (selectedCounsellor) {
                await deleteCounsellor({ id: selectedCounsellor.id });
                alert("Counsellor deleted successfully!");
                fetchCounsellors();
            }
        } catch (error) {
            console.error("Error deleting counsellor:", error);
            alert("Failed to delete counsellor.");
        } finally {
            setIsDeletePopupOpen(false);
            setSelectedCounsellor(null);
        }
    };

    const handleCloseDeletePopup = () => {
        setIsDeletePopupOpen(false);
        setSelectedCounsellor(null);
    };

    const handleEditClick = (counsellor) => {
        setCounsellorToUpdate(counsellor); // Store the counsellor to update
        setIsUpdatePopupOpen(true); // Open the update popup
    };

    const handleCloseUpdatePopup = () => {
        setIsUpdatePopupOpen(false);
        setCounsellorToUpdate(null);
    };

    const handleUpdateCounsellor = async (id, updatedCounsellorData) => {
        try {
            await updateCounsellor({
                id,
                name: updatedCounsellorData.name,
                designation: updatedCounsellorData.designation,
                tele: updatedCounsellorData.tele,
                email: updatedCounsellorData.email,
            });
            alert("Counsellor updated successfully!");
            fetchCounsellors();
        } catch (error) {
            console.error("Error updating counsellor:", error);
            alert("Failed to update counsellor.");
        }
    };

    return (
        <PageComponent>
            <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
                <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
                    <Sidebar />
                </div>
                <div className="flex-1 p-6 ml-64">
                    <div className="flex items-center space-x-2 text-3xl text-gray-500">
                        <span>Student Support</span>
                        <span>/</span>
                        <span className="text-black">Student Counsellor</span>
                    </div>

                    <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
                        <h2 className="mb-4 text-xl font-semibold text-gray-700">Add Counsellor</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block mb-2 text-gray-700">Name</label>
                                    <input
                                        type="text"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        placeholder="Enter name"
                                        className="w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-md focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 text-gray-700">Designation</label>
                                    <input
                                        type="text"
                                        value={designation}
                                        onChange={(e) => setDesignation(e.target.value)}
                                        placeholder="Enter designation"
                                        className="w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-md focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 text-gray-700">Phone Number</label>
                                    <input
                                        type="text"
                                        value={tele}
                                        onChange={(e) => setTele(e.target.value)}
                                        placeholder="Enter phone number"
                                        className="w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-md focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 text-gray-700">Email</label>
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Enter email"
                                        className="w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-md focus:outline-none"
                                    />
                                </div>
                            </div>

                            <div className="flex justify-end mt-12 space-x-4">
                                <button
                                    type="reset"
                                    onClick={() => {
                                        setName("");
                                        setDesignation("");
                                        setTele("");
                                        setEmail("");
                                        setEditId(null);
                                    }}
                                    className="px-4 py-2 text-[#A8AAAE] bg-gray-200 rounded-md hover:bg-gray-300"
                                >
                                    Clear
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
                                >
                                    Add
                                </button>
                            </div>
                        </form>
                    </div>

                    {/* Counsellor Table */}
                    <div className="p-4 mt-4 bg-white border border-gray-300 rounded-lg shadow-md">
                        <h2 className="mb-4 text-xl font-semibold text-gray-700">Added Counsellors</h2>
                        <table className="w-full border border-gray-300 table-auto">
                            <thead>
                                <tr className="text-left text-gray-600 bg-gray-100">
                                    <th className="px-4 py-2">#</th>
                                    <th className="px-4 py-2">Name</th>
                                    <th className="px-4 py-2">Designation</th>
                                    <th className="px-4 py-2">Phone Number</th>
                                    <th className="px-4 py-2">Email</th>
                                    <th className="px-4 py-2">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {counsellors.length > 0 ? (
                                    counsellors.map((item, index) => (
                                        <tr key={item.id} className="border-b border-gray-300">
                                            <td className="px-4 py-2">{index + 1}</td>
                                            <td className="px-4 py-2">{item.name}</td>
                                            <td className="px-4 py-2">{item.designation}</td>
                                            <td className="px-4 py-2">{item.tele}</td>
                                            <td className="px-4 py-2">{item.email}</td>
                                            <td className="px-4 py-2">
                                                <div className="flex items-center space-x-4">
                                                    <button
                                                        type="button"
                                                        className="flex items-center px-5 py-1 text-gray-400 bg-gray-100 border border-gray-400 rounded"
                                                        onClick={() => handleDeleteClick(item)}
                                                    >
                                                        Delete
                                                        <MdOutlineDeleteForever className="w-5 h-5 ml-2" />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="flex items-center px-5 py-1 border rounded text-primary-color border-primary-color bg-primary-color bg-opacity-10"
                                                        onClick={() => handleEditClick(item)}
                                                    >
                                                        Edit
                                                        <FaRegEdit className="w-4 h-4 ml-2" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="px-4 py-2 text-center text-gray-500">
                                            No counsellors available.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Delete Confirmation Popup */}
                <DeletePopup
                    title="Counsellor"
                    isOpen={isDeletePopupOpen}
                    onClose={handleCloseDeletePopup}
                    onConfirm={handleConfirmDelete}
                    data={selectedCounsellor?.name || ""}
                />

                {/* Update Counsellor Popup */}
                <UpdateCounsellorPopup
                    title="Update Counsellor"
                    isOpen={isUpdatePopupOpen}
                    onClose={handleCloseUpdatePopup}
                    fetchCounsellors={fetchCounsellors}
                    updateCounsellor={handleUpdateCounsellor}
                    data={counsellorToUpdate}
                />
            </div>
        </PageComponent>
    );
}

export default Student_Counseller;